import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const SmallCars = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <div className="small-cars">
      <div className="info" data-aos="fade-up">
        <img src="https://images2.alphacoders.com/109/1093754.jpg" alt="" />
      </div>
      <div className="info" data-aos="fade-up">
        <p>
          Another reason people often drink in social settings is peer pressure.
          It’s culturally the norm for people in Western countries to drink when
          they’re out in groups or to enjoy beer and wine together during social
          visits. For people who want to fit in with a group of friends, an
          unspoken pressure applies that encourages them to drink when they
          otherwise wouldn’t. For young adults, a variety of binge-drinking
          cultures operate in various settings, especially college campuses, in
          which drinking dangerously large amounts of alcohol is almost a
          requirement for membership in peer groups.
        </p>
      </div>
      <div className="info" data-aos="fade-up">
        <p>
          Alcohol is the most commonly used substance in the United States, and
          as a result, it’s the most commonly abused as well. Nearly 70% of
          Americans drink, and up to 15 million adults have a substance abuse
          disorder. Very often, these problems begin with social drinking, in
          which alcohol is used in groups and to have a good time. This split,
          between the tragic consequences of alcohol abuse and the evident
          pleasure people get out of drinking, has led many people to ask, “Why
          do people like getting drunk?” The answers seem to be based in society
          and psychology as much as in chemistry and biology. To understand why
          people enjoy the sensation of being intoxicated, it helps to
          understand what alcohol is and how it affects human bodies.
        </p>
      </div>
      <div className="info">
        <Link to="/cocktails">
          <button className="btn">Search</button>
        </Link>
      </div>
      <div className="info" data-aos="fade-up">
        <img
          src="https://c4.wallpaperflare.com/wallpaper/862/976/17/alcohol-bottles-whiskey-jack-daniels-wallpaper-preview.jpg"
          alt=""
        />
      </div>
    </div>
  );
};

export default SmallCars;
